<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="FM-Epigraph---non-verse-fmepi">Death is not an individual but a social event. When, with a barely noticeable sigh, the last gasp of air is exhaled, the blood stops pulsating through arteries and veins, and neurons cease activating the brain, the life of a human organism has ended. Death is not official, however, until the community takes notice.</p>
<p class="FM-Epigraph-Source-fmeps_1"><span class="ePub-SC">—STEFAN TIMMERMANS</span></p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-I">Postmortem: How Medical Examiners Explain Suspicious Deaths</span></p>
<p class="FM-Epigraph---non-verse-fmepi">Every man’s life ends the same way. It is only the details of how he lived and how he died that distinguish one man from another.</p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-SC">—ERNEST HEMINGWAY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?675b4d6a